import React from 'react';

import { VideoBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { Body, RichTextHeadline } from 'components/Text';
import Video from 'components/Video';

type Props = {
  blockIndex: number;
  data: VideoBlockData;
  fullWidthLayout?: boolean;
};

export function VideoBlock({
  blockIndex,
  data: { headline, subtitle, videoUrl },
  fullWidthLayout,
}: Props) {
  return (
    <Box>
      {(headline || subtitle) && (
        <Box mb={48}>
          {headline && (
            <RichTextHeadline textAlign={fullWidthLayout ? 'center' : 'left'}>
              {headline}
            </RichTextHeadline>
          )}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Video',
                },
              }}
              textAlign={fullWidthLayout ? 'center' : 'left'}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </Box>
      )}
      <Video prefix="cms-embed" url={videoUrl} />
    </Box>
  );
}
